import { render, staticRenderFns } from "./orderDetailTransport.vue?vue&type=template&id=43763e6e"
import script from "./orderDetailTransport.vue?vue&type=script&lang=js"
export * from "./orderDetailTransport.vue?vue&type=script&lang=js"
import style0 from "./orderDetailTransport.vue?vue&type=style&index=0&id=43763e6e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43763e6e')) {
      api.createRecord('43763e6e', component.options)
    } else {
      api.reload('43763e6e', component.options)
    }
    module.hot.accept("./orderDetailTransport.vue?vue&type=template&id=43763e6e", function () {
      api.rerender('43763e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/components/orderDetailTransport.vue"
export default component.exports